import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonSize, ButtonVariant} from '@/components/common/content/ButtonTypes'
import {Text, TextVariant} from '@/components/common/content/Text'
import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {analytics} from '@/utils/tracking/analytics'

type NavigationLinkProps = {
  label: string
  linkHref: string
  trackedEvent: string
  closeNavigation?: () => void
  isMobile?: boolean
}

export const NavigationLink: FC<React.PropsWithChildren<NavigationLinkProps>> = ({
  label,
  linkHref,
  trackedEvent,
  closeNavigation,
  isMobile,
}) => {
  const handleClick = () => {
    analytics.track(trackedEvent)
    closeNavigation && closeNavigation()
  }

  if (isMobile) {
    return (
      <>
        <Link href={linkHref} legacyBehavior>
          <a className="link" onClick={() => handleClick()} role="link" tabIndex={0}>
            <Text variant={TextVariant.subtitle12} color={theme.palette.text.white}>
              {label}
            </Text>
          </a>
        </Link>

        <style jsx>{`
          .link {
            display: block;
            padding: ${theme.spacing[3]} 0;
          }
        `}</style>
      </>
    )
  }

  return (
    <Link href={linkHref} onClick={() => handleClick()}>
      <Button
        type="button"
        size={ButtonSize.small}
        variant={ButtonVariant.darkGray}
        hasBorder={false}
      >
        {label}
      </Button>
    </Link>
  )
}
